import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 dark:from-brand-900/40 to-accent-50 dark:to-zinc-950 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="text-8xl mb-6 animate-bounce">🃏</div>
        <h1 className="text-7xl font-display font-bold text-brand-600 dark:text-brand-400 mb-2">404</h1>
        <h2 className="text-2xl font-bold text-gray-800 dark:text-zinc-200 mb-3">Page not found</h2>
        <p className="text-gray-500 dark:text-zinc-500 max-w-md mx-auto mb-8">
          Looks like this card's been traded away. The page you're looking for doesn't exist or may have moved.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">Go Home</Link>
          <Link to="/explore" className="btn-outline">Explore Cards</Link>
          <Link to="/marketplace" className="btn-outline">Marketplace</Link>
        </div>
      </div>
    </div>
  );
}
